import {
  Card,
  DataStatus,
  Form,
  FormButton,
  FormField,
  FormSubmitHandler,
  showNotification,
} from 'platform/components';
import {Right, VStack} from 'platform/foundation';

import {
  useGetTipCarsDefaultSettingsQuery,
  useSetTipCarsDefaultSettingsMutation,
} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {useBranchId} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

type PlatformTipCarsVinFormData = {
  vinHidden: boolean;
};

export function PlatformTipCarsVin() {
  const branchId = useBranchId();
  const {data, isFetching, isError} = useGetTipCarsDefaultSettingsQuery({branchId});
  const [saveSettings] = useSetTipCarsDefaultSettingsMutation();

  const onSubmit: FormSubmitHandler<PlatformTipCarsVinFormData> = (values, _setErrors, reset) =>
    saveSettings({...values, branchId})
      .unwrap()
      .then(() => {
        showNotification.success(
          i18n.t('entity.advertisingPlatforms.notifications.credentialsSaved')
        );
        reset(undefined, {keepValues: true});
      })
      .catch(handleApiError);

  return (
    <Card title={i18n.t('general.labels.defaultSettings')}>
      <DataStatus isLoading={isFetching} isError={isError} minHeight={25}>
        <Form<PlatformTipCarsVinFormData>
          values={data}
          onSubmit={onSubmit}
          shouldWatchForUnsavedChanges
        >
          {(control) => (
            <VStack spacing={4}>
              <FormField
                control={control}
                name="vinHidden"
                type="switch"
                label={i18n.t('page.settings.labels.vinHidden')}
              />
              <Right>
                <FormButton
                  control={control}
                  type="submit"
                  title={i18n.t('general.actions.save')}
                />
              </Right>
            </VStack>
          )}
        </Form>
      </DataStatus>
    </Card>
  );
}
